import Office from "./Office";

export default class Offices {
  constructor(element) {
    this.rootElement = element;
    if (!element) {
      return;
    }
    this.settings = Object.assign({}, element.dataset);

    this.mapElement = element.querySelector('[data-offices-map]');
    this.map = undefined;
    this.placemark = undefined;

    this.activeTab = undefined;
    this.activeTabType = 'offices';

    this.listElement = element.querySelector('[data-offices-list]');
    this.backLinks = element.querySelectorAll('[data-office-back-link]');
    this.listHeight = this.listElement.clientHeight;
    this.offices = [];
    this.activeOffice = undefined;

    this.iconImage = this.mapElement.dataset.mark;

    this.isOneOffice = this.checkIsOneOffice();

    this.iconImageSize = [26, 26];
    this.iconImageOffset = [-17, -20];

    if (this.isOneOffice) {
      this.iconImageSize = [60, 60];
      this.iconImageOffset = [-17, -30];
    }

    this.initMapPending();
  }

  isMobile() {
    return window.innerWidth < 768;
  }

  initMapPending() {
    if (window.ymaps) {
      this.initMap();
      return;
    }
    setTimeout(() => {
      this.initMapPending();
    }, 500);
  }

  initMap() {
    ymaps.ready(() => {
      this.initTabs();
      this.placemarkImage();
      this.initObjects();
      this.createMap();
      this.bindTabs();
      this.mapFilter();
    });

    setTimeout(() => {
      this.setPlacemarkClass();
    },500);
  }

  initTabs() {
    this.tabs = this.rootElement.querySelectorAll('[data-offices-tab]:not([data-initialized="true"])');
    if (this.tabs.length > 0) {
      this.activeTab = this.tabs[0];
      this.activeTabType = this.activeTab.dataset.officesTab;
      this.setTabInitialized(this.activeTab);
    }
  }

  initObjects() {
    this.oneOfficePlacemarkSettings();
    this.rootElement.querySelectorAll('[data-list-item]')
      .forEach((listItemElement) => {
        const office = new Office(listItemElement);
        const placemark = this.initPlacemark([office.getLat(), office.getLng()]);

        office.setPlacemark(placemark);

        placemark.events.add('click', () => {
          this.onPlacemarkClick(office);
        });

        listItemElement.addEventListener('click', () => {
          this.onListElementClick(office);
        });

        this.offices.push(office);
      });
    if (this.isMobile()) {
      this.setDefaultListHeight();
    }

    this.initBackLinks();
  }

  initPlacemark(coords) {
    this.placemark = new ymaps.Placemark(coords, {}, {
      // Опции.
      // Необходимо указать данный тип макета.
      iconLayout: 'default#image',
      // Своё изображение иконки метки.
      iconImageHref: this.iconImage,
      // Размеры метки.
      iconImageSize: this.iconImageSize,
      // Смещение левого верхнего угла иконки относительно
      // её "ножки" (точки привязки).
      iconImageOffset: this.iconImageOffset,
    });
    return this.placemark;
  }

  createMap() {
    const rect = this.mapElement.getBoundingClientRect();
    let bottom = 220;
    if (rect.height) {
      bottom = (rect.height/2 - 30);
    }

    this.map = new ymaps.Map(this.mapElement, {
      center: [0, 0],
      zoom: 17,
      controls: ['zoomControl'],
    }, {
      zoomControlPosition: { right: 10, top: 'auto', left: 'auto', bottom: bottom + 'px' },
      zoomControlSize: 'small',
    });

    this.map.behaviors.disable('scrollZoom');

    this.map.margin.setDefaultMargin(this.getMapMargin());

    this.fitCenter();

    this.offices.map((office) => {
      if (office.settings.type === this.activeTab.dataset.officesTab) {
        this.map.geoObjects.add(office.getPlacemark());
      }
    })
  }

  getCenterCoordsByAllVisibleOffices() {
    // Берем все координаты от всех точек
    let minLat;
    let minLng;
    let maxLat;
    let maxLng;

    this.offices.forEach((office) => {
      if (office.settings.type === this.activeTab.dataset.officesTab) {
        if (minLat === undefined || minLat > office.getLat()) {
          minLat = office.getLat();
        }
        if (maxLat === undefined || maxLat < office.getLat()) {
          maxLat = office.getLat();
        }

        if (minLng === undefined || minLng > office.getLng()) {
          minLng = office.getLng();
        }
        if (maxLng === undefined || maxLng < office.getLng()) {
          maxLng = office.getLng();
        }
      }
    });

    return [[minLat, minLng], [maxLat, maxLng]];
  }

  fitCenter() {
    const coords = this.getCenterCoordsByAllVisibleOffices();
    let minLat = coords[0][0];
    let minLng = coords[0][1];
    let maxLat = coords[1][0];
    let maxLng = coords[1][1];
    if (minLat === maxLat && minLng === maxLng) {
      // Если офис один, то центрируем карту и берем зум от этого офиса (офис активной вкладки)
      const office = this.offices.find((item) => item.settings.type === this.activeTab.dataset.officesTab);
      this.moveMapCenterTo(
          [office.getLat(), office.getLng()],
          parseInt(office.settings.zoom, 10)
      );
    } else {
      // Определяем центр и оптимальный зум
      ymaps.util.requireCenterAndZoom(
          this.map.getType(),
          coords,
          this.map.container.getSize(),
          { margin: this.getMapMargin() },
      ).then((result) => {
        this.map.setCenter(result.center, result.zoom, {duration: 500});
      });
    }
  }

  getMapMargin() {
    if (this.isMobile()) {
      return [31, 31, 31, 31];
    }

    if (this.settings.mode === 'container') {
      const listLeft = parseInt(getComputedStyle(this.listElement).left, 10);
      const leftOffset = this.listElement.offsetWidth + listLeft;
      return [62, 62, 62, leftOffset + 62];
    } else {
      const bounds = this.listElement.getBoundingClientRect();
      return [62, 62, 62, bounds.right + 62];
    }
  }

  moveMapCenterTo(coords, officeZoom) {
    if (this.isMobile()) {
      if (!isNaN(officeZoom)) {
        this.map.setCenter(coords, officeZoom);
      } else {
        this.map.setCenter(coords, 16);
      }
    } else {
      if (!isNaN(officeZoom) && this.map.getZoom() !== officeZoom) {
        this.map.setZoom(officeZoom, {duration: 600})
            .then(() => {
              this.map.panTo(
                  coords, {
                    duration: 600,
                    flying: true,
                    useMapMargin: true,
                  },
              );
            });
      } else {
        this.map.panTo(
            coords, {
              duration: 600,
              flying: true,
              useMapMargin: true,
            },
        );
      }
    }
  }

  refreshMap() {
    if (this.isMobile()) {
      this.map.container.fitToViewport();
    }
  }

  onListElementClick(office) {
    this.activateOffice(office);
  }

  deactivateOffice() {
    if (this.activeOffice) {
      this.activeOffice.getPlacemark().options.set({
        iconImageSize: this.iconImageSize,
        iconImageOffset: this.iconImageOffset,
      });
      this.activeOffice = null;
    }
  }

  activateOffice(office) {
    this.deactivateOffice();
    // Список той вкладки, к которой относится точка (вкладок может быть несколько)
    office.listItemElement.closest('[data-offices-list-item]').classList.add('_hidden');
    const officeId = office.listItemElement.dataset.id;
    const officeElement = document.querySelector(`[data-list-item-card="${officeId}"]`);
    officeElement.classList.add('_active');
    this.checkMobileList(officeElement, true);
    office.getPlacemark().options.set({
      iconImageSize: this.iconImageSize,
      iconImageOffset: this.iconImageOffset,
    });
    this.refreshMap();
    this.moveMapCenterTo([office.getLat(), office.getLng()], parseInt(office.settings.zoom, 10));
    this.activeOffice = office;
  }

  removePlacemarks() {
    this.offices.forEach((office) => {
      this.map.geoObjects.remove(office.getPlacemark());
    });
  }

  setActivePlacemarksByActiveTab() {
    this.offices.map((office) => {
      if (office.settings.type === this.activeTab.dataset.officesTab) {
        this.placemark.options.set('iconImageHref', this.iconImage);
        this.map.geoObjects.add(office.getPlacemark());
      }
    });
  }

  bindTabs() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.activeTab = tab;
        this.activeTabType = tab.dataset.officesTab;
        this.removePlacemarks();
        this.placemarkImage();
        this.oneOfficePlacemarkSettings();

        if (!this.activeTab.getAttribute('data-initialized')) {
          this.offices.map((office) => {
            if (office.settings.type === this.activeTab.dataset.officesTab) {
              office.defineHeight();
            }
          });

          this.setTabInitialized(this.activeTab);
        }

        this.fitCenter();

        setTimeout(() => {
          this.setActivePlacemarksByActiveTab();
        }, 600);

        setTimeout(() => {
          this.setPlacemarkClass();
        }, 650);
      });
    })
  }

  onPlacemarkClick(office) {
    this.activateOffice(office);
  }

  setTabInitialized(tab) {
    tab.setAttribute('data-initialized', 'true');
  }

  setPlacemarkClass() {
    if (this.checkIsOneOffice()) {
      const version = this.getVersion();
      const placemarkClass = `ymaps-${version}-image`;
      const placemark = document.querySelector(`.${placemarkClass}`);

      if (placemark && !placemark.classList.contains('contacts-top__placemark')) {
        placemark.classList.add('contacts-top__placemark');
      }
    }
  }

  mapFilter() {
    const version = this.getVersion();
    const groundPaneClass = `ymaps-${version}-ground-pane`;
    const groundPane = document.querySelector(`.${groundPaneClass}`);

    if (groundPane) {
      groundPane.firstChild.style.filter = 'grayscale(100%)';
    }
  }

  getVersion() {
    return ymaps.meta.version.replace(/\./g, '-')
  }

  placemarkImage() {
    if (this.checkIsOneOffice()) {
      const imagePath = this.activeTab.dataset.officePlacemark;
      if (imagePath) {
        this.iconImage = imagePath;
      }
    }
  }

  checkIsOneOffice() {
    return this.rootElement.querySelectorAll(`[data-type=${this.activeTabType}`).length === 1;
  }

  initBackLinks() {
    this.backLinks.forEach((backLink) => {
      backLink.addEventListener('click', () => {
        const officeId = backLink.dataset.officeBackLink;
        const officeElement = document.querySelector(`[data-list-item-card="${officeId}"]`);

        officeElement.closest('[data-offices-list]')
          .querySelector('[data-offices-list-item]')
          .classList.remove('_hidden');

        if (officeElement.classList.contains('_active')) {
          officeElement.classList.remove('_active');
        }

        this.checkMobileList(officeElement, false);
      });
    });
  }

  checkMobileList(officeElement, open) {
    if (!this.isMobile() || this.isSingleList(officeElement.closest('[data-offices-list]'))) {
      return;
    }

    const officeElementHeight = officeElement.children[0].clientHeight;

    if (open) {
      this.listElement.style.height = `${officeElementHeight}px`;
    } else {
      this.setDefaultListHeight();
    }
  }

  setDefaultListHeight() {
    // У одной точки высоту задаёт карточка — фиксировать её нельзя (картинка догрузится позже)
    if (this.isSingleList(this.listElement)) {
      return;
    }
    this.listElement.style.height = `${this.listHeight}px`;
  }

  isSingleList(listElement) {
    return !!listElement && listElement.hasAttribute('data-single');
  }

  oneOfficePlacemarkSettings() {
    if (!this.placemark) {
      return;
    }

    if (this.checkIsOneOffice()) {
      this.iconImageSize = [60, 60];
      this.iconImageOffset = [-17, -30];
      this.placemark.options.set('iconImageSize', this.iconImageSize);
      this.placemark.options.set('iconImageOffset', this.iconImageOffset);
      this.setPlacemarkClass();
    }
  }
}